(()=>{
  const script=document.currentScript;
  const root=(script.dataset.root||'/').replace(/\/?$/, '/');const locale=script.dataset.locale||'lv';
  const names=['Iepriekšpasūtījums','Pre-order','Išankstinis užsakymas','Ettetellimus'];
  const clean=(properties,quantity)=>{const out={...properties};if(out._mv21_preorder==='1'){
    const previous=`${out._mv21_preorder_lead} · ${out._mv21_preorder_qty} / ${quantity}`;
    const custom=Object.keys(out).filter(key=>!key.startsWith('_')&&out[key]===previous);
    for(const key of [...names,...custom,out._mv21_preorder_label,'_mv21_preorder','_mv21_preorder_qty','_mv21_preorder_lead','_mv21_preorder_label'])if(key)delete out[key];
  }return out;};
  const equal=(a,b)=>JSON.stringify(Object.entries(a).sort())===JSON.stringify(Object.entries(b).sort());
  async function json(url,options){const r=await fetch(url,options);const data=await r.json();if(!r.ok)throw Error('Cart update failed');return data;}
  const read=()=>json(root+'cart.js');
  const update=body=>json(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
  let busy=false,unresolved=false;
  const retry={lv:'Lūdzu, vēlreiz atjauno preces daudzumu grozā, lai pārbaudītu pieejamību.',en:'Please update the cart quantity again to verify availability.',lt:'Dar kartą atnaujinkite kiekį krepšelyje, kad patikrintumėte prieinamumą.',et:'Saadavuse kontrollimiseks uuenda ostukorvis kogust uuesti.'};
  const adjusted={lv:n=>`Grozam ${n%10===1&&n%100!==11?'pievienots':'pievienoti'} ${n} gab. Sasniegts šobrīd pieejamais daudzums.`,en:n=>`${n} ${n===1?'item':'items'} added to your cart. Your cart now contains all currently available stock.`,lt:n=>`Į krepšelį pridėta ${n} vnt. Krepšelyje jau yra visas šiuo metu turimas kiekis.`,et:n=>`Ostukorvi lisati ${n} tk. Ostukorvis on nüüd kogu hetkel saadaolev kogus.`};
  let checkoutApproved=false;
  const guard=async event=>{
    const target=(event.submitter||event.target).closest?.('[name="checkout"],a[href*="/checkout"],form[action*="/checkout"]');
    if(!target||checkoutApproved)return;
    event.preventDefault();event.stopImmediatePropagation();if(busy)return;
    try{
      await window.MV21RestockCart.check();
      checkoutApproved=true;
      try{if(event.type==='submit')event.target.requestSubmit(event.submitter||undefined);else target.click();}
      finally{checkoutApproved=false;}
    }catch{
      let notice=document.getElementById('mv21-cart-check-error');
      if(!notice){notice=document.createElement('p');notice.id='mv21-cart-check-error';notice.setAttribute('role','alert');target.before(notice);}
      notice.textContent=retry[locale]||retry.en;
    }
  };
  document.addEventListener('click',guard,true);document.addEventListener('submit',guard,true);
  const resolved=cart=>{unresolved=false;document.getElementById('mv21-cart-check-error')?.remove();return cart;};
  async function reconcile(cart,variant){
      // Changes to properties can merge lines and change keys. Always use the
      // latest Shopify response and recalculate allocation before the next write.
      for(let attempt=0;attempt<50;attempt++){
        const lines=cart.items.filter(i=>String(i.variant_id)===variant);if(!lines.length)return cart;
        const total=lines.reduce((sum,i)=>sum+i.quantity,0);
        const quote=await json(root+'apps/mv21-restock/quote?'+new URLSearchParams({variant,quantity:total,locale}));
        if(!['preorder','stock'].includes(quote.mode))throw Error('Availability changed');
        let available=total-quote.preorderQuantity;let change;
        for(const line of lines){
          const missing=Math.max(0,line.quantity-available);available=Math.max(0,available-line.quantity);
          const properties=clean(line.properties||{},line.quantity);
          if(missing){
            const lead=line.properties?._mv21_preorder_lead||quote.lead;
            const label=Object.keys(quote.properties).find(n=>!n.startsWith('_'))||names[0];
            Object.assign(properties,{[label]:`${lead} · ${missing} / ${line.quantity}`,_mv21_preorder:'1',_mv21_preorder_label:label,_mv21_preorder_qty:String(missing),_mv21_preorder_lead:lead});
          }
          if(!equal(properties,line.properties||{})){change={id:line.key,quantity:line.quantity,properties};break;}
        }
        if(!change)return cart;
        cart=await update(change);
      }
      throw Error('Cart reconciliation incomplete');
  }
  window.MV21RestockCart={
    async check(){
      if(busy)throw Error('Cart update in progress');busy=true;
      try{
        let cart=await read();
        for(const variant of new Set(cart.items.map(i=>String(i.variant_id))))cart=await reconcile(cart,variant);
        return resolved(cart);
      }catch(error){unresolved=true;throw error;}finally{busy=false;}
    },
    async add(body){
      if(busy)throw Error('Cart update in progress');busy=true;
      try{
        const params=new URLSearchParams(body);const variant=params.get('id');const quantity=Number(params.get('quantity')||1);
        if(!/^\d+$/.test(variant)||!Number.isInteger(quantity)||quantity<1)throw Error('Invalid selection');
        const cart=await read();const cartQuantity=cart.items.filter(i=>String(i.variant_id)===variant).reduce((sum,i)=>sum+i.quantity,0);
        const quote=await json(root+'apps/mv21-restock/quote?'+new URLSearchParams({variant,quantity,cartQuantity,locale}));
        const remaining=Number.isInteger(quote.stockQuantity)?Math.max(0,quote.stockQuantity-cartQuantity):0;
        const capped=quote.mode==='restock'&&remaining>0;
        if(capped)params.set('quantity',String(Math.min(quantity,remaining)));
        if(!capped&&!['preorder','stock'].includes(quote.mode))return {json:async()=>({status:422,description:retry[locale]||retry.en})};
        const previous=Object.fromEntries([...params].filter(([key])=>key.startsWith('properties[')&&key.endsWith(']')).map(([key,value])=>[key.slice(11,-1),value]));
        const properties={...clean(previous,quantity),...quote.properties};
        if(properties._mv21_preorder==='1')properties._mv21_preorder_label=Object.keys(quote.properties).find(key=>!key.startsWith('_'));
        for(const key of [...params.keys()])if(key.startsWith('properties['))params.delete(key);
        for(const [key,value] of Object.entries(properties))params.set(`properties[${key}]`,value);
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded','X-Requested-With':'XMLHttpRequest'},body:params.toString()});
        // Never turn an accepted add into a retryable failure: that could add twice.
        // If reconciliation fails, the checkout guard keeps the cart blocked.
        if(response.ok){try{resolved(await reconcile(await read(),variant));}catch{unresolved=true;}}
        if(response.ok&&capped){const data=await response.json();return {ok:true,json:async()=>({...data,mv21QuantityNotice:(adjusted[locale]||adjusted.en)(Number(params.get('quantity')))})};}
        return response;
      }finally{busy=false;}
    },
    async change(key,quantity){
    if(busy)throw Error('Cart update in progress');
    if(!Number.isInteger(quantity)||quantity<0)throw Error('Invalid quantity');
    busy=true;
    try{
      let cart=await read();const original=cart.items.find(i=>i.key===key);if(!original)throw Error('Cart changed');
      const variant=String(original.variant_id);
      cart=await update({id:key,quantity});
      return resolved(await reconcile(cart,variant));
    }catch(error){unresolved=true;throw error;}finally{busy=false;}
  }};
})();
